/* VAELON theme interactions */
(function () {
  /* ---- scroll reveal ---- */
  function reveal() {
    var els = document.querySelectorAll('.rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
    document.querySelectorAll('.hero .rv, .duo .rv').forEach(function (e) { e.classList.add('in'); });
  }

  /* ---- variant picker ---- */
  function initVariants() {
    var variants = window.__variants;
    var sel = document.getElementById('variant-id');
    if (!variants || !sel) return;
    var priceEl = document.getElementById('pdp-price');
    var atc = document.getElementById('atc-btn');
    var symbol = '£';
    if (priceEl) { var m = priceEl.textContent.replace(/[\\d.,\\s]/g, ''); if (m) symbol = m.trim().charAt(0) || '£'; }

    function money(c){ return symbol + (c / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

    function hasActiveBundle() {
      /* Bundle sections (taebaek, bundle3, bundle4) own the ATC label themselves
         whenever a multi-qty option is selected — don't fight them here. */
      var activeOpt = document.querySelector('.bundle .bundle-opt.on, .bundle3 .bundle-opt.on, .bundle4 .bundle-opt.on');
      if (!activeOpt) return false;
      var qty = parseInt(activeOpt.getAttribute('data-qty'), 10);
      return qty > 1;
    }

    function chosen() {
      var groups = document.querySelectorAll('.opt');
      var vals = [];
      groups.forEach(function (g) {
        var on = g.querySelector('.opt-val.on');
        vals.push(on ? on.getAttribute('data-value') : null);
      });
      return vals;
    }
    function match() {
      var vals = chosen();
      if (!vals.length) return variants[0];
      return variants.find(function (v) {
        return vals.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }
    function update() {
      var v = match();
      if (!v) return;
      sel.value = v.id;
      if (priceEl) {
        var now = priceEl.querySelector('.now');
        var cmp = priceEl.querySelector('s');
        var off = priceEl.querySelector('.off');
        if (now) { now.textContent = money(v.price); } else { priceEl.textContent = money(v.price); }
        if (v.compare_at_price && v.compare_at_price > v.price) {
          if (cmp) { cmp.style.display = ''; cmp.textContent = money(v.compare_at_price); }
          if (off) { off.style.display = ''; off.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%'; }
        } else {
          if (cmp) cmp.style.display = 'none';
          if (off) off.style.display = 'none';
        }
      }
      if (atc) {
        atc.disabled = !v.available;
        if (!v.available) {
          atc.textContent = 'Sold out';
        } else if (!hasActiveBundle()) {
          atc.textContent = 'Add to bag';
        }
        /* else: a bundle option with qty > 1 is active — leave the label alone,
           the bundle3/bundle4 click handlers own it (and set it correctly on load too). */
      }
    }
    document.querySelectorAll('.opt-val').forEach(function (b) {
      b.addEventListener('click', function () {
        var grp = b.closest('.opt');
        grp.querySelectorAll('.opt-val').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        update();
      });
    });
    update();
  }

  document.addEventListener('DOMContentLoaded', function () { reveal(); initVariants(); });
  if (document.readyState !== 'loading') { reveal(); initVariants(); }
})();
